/**
 * Slate library (https://docs.slatejs.org/) is used for implementing rich text editor functionality
 */

import html from './html-serializer';
import * as renderers from './renderers';
import * as marks from './marks';
import * as links from './links';
import * as eventHooks from './eventHooks';

export default {
	html,
	...renderers,
	...marks,
	...links,
	...eventHooks,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/RichTextEditor/helpers/index.ts